if ($('.bod-section__gallery').length) {
	var $bodElement = $('.bod-item');

	if ($bodElement.length > 0) {

		var $items = $bodElement,
			$itemExp = $('.bod-expanded'),
			$itemIco = $('.icon-bod'),
			$close = $('.bod-expanded__close');

		checkHash();

		function openBod(object) {
			var $this = $(object);

			var $items = $this.closest('.js-bod-section').find('.bod-item'),
				$itemExp = $this.closest('.js-bod-section').find('.bod-expanded'),
				$itemIco = $this.closest('.js-bod-section').find('.icon-bod'),
				$close = $this.closest('.js-bod-section').find('.bod-expanded__close');
			if (!$this.hasClass('bod-item--exp')) {
				var imgSrc = $this.find('img').attr('src'),
					imgAlt = $this.find('img').attr('alt'),
					name = $this.find('.bod-item__name').html(),
					post = $this.find('.bod-item__post').html(),
					desc = $this.find('.bod-content__hidden').html(),
					ico = $this.find('.bod-item--icon-bod').html(),
					hashCode = $this.data('hash');
				$items.removeClass('bod-item--exp');
				$this.addClass('bod-item--exp');
				$itemExp
					.find('.bod__photo')
					.attr('src', imgSrc);
				$itemExp
					.find('.bod__photo')
					.attr('alt', imgAlt);
				$itemExp
					.find('.bod__name')
					.html(name);
				$itemExp
					.find('.bod__post')
					.html(post);
				$itemExp
					.find('.bod-content')
					.html(desc);
				$itemIco
					.html(ico);
				$itemExp.velocity('slideDown', {duration: 400});
				window.location.hash = hashCode;

				scrollToElement($itemExp);
			}
		}

		function slideUpExpanded() {
			$itemExp.velocity('slideUp', {duration: 400});
			$items.removeClass('bod-item--exp');
			window.location.hash = '!';
		}

		$items.on('click', function () {
			openBod(this);
		});

		$close.on('click', slideUpExpanded);

		$(document).on('keydown', function (e) {
			if (e.keyCode == 27) {
				slideUpExpanded();
			}
		});

		function checkHash() {
			var arrHashes = [];
			for (var i = 0; i < $bodElement.length; i++) {
				arrHashes[i] = $bodElement.eq(i).data('hash');
			}

			if (window.location.hash) {
				var hash = window.location.hash.substr(1),
					hashIndexOf = arrHashes.indexOf(hash);
				if (hashIndexOf == -1 & hash != '') {
					window.location.hash = '!';
				} else {
					scrollToHashElement(hash);
				}
			}
		}

		function scrollToHashElement(hash) {
			var $currentMan = $('.bod-item[data-hash="' + hash + '"]');
			openBod($currentMan);
			$itemExp = $currentMan.closest('.js-bod-section').find('.bod-expanded');
			setTimeout(function () {
				scrollToElement($itemExp);
			}, 300);
		}
	}

	function scrollToElement(bodContent) {
		var topPos = bodContent.offset().top;
		$('html')
			.velocity('scroll', {
				offset: topPos - 108 + 'px',
				duration: 500,
				mobileHA: false
			});
	}
}



// WEBPACK FOOTER //
// ./temp/components/bod/bod-gallery/index.js